import(/* webpackMode: "eager", webpackExports: ["AppointmentSection"] */ "/vercel/path0/src/components/sections/appointment-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitsStrip"] */ "/vercel/path0/src/components/sections/benefits-strip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComparisonSection"] */ "/vercel/path0/src/components/sections/comparison-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqSection"] */ "/vercel/path0/src/components/sections/faq-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/vercel/path0/src/components/sections/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeSectionScroll"] */ "/vercel/path0/src/components/sections/home-section-scroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/reviews-recommendations-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TransformationDashboard"] */ "/vercel/path0/src/components/sections/transformation-dashboard.tsx");
